import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";

interface BankDetailsModalProps {
  name: string;
  open: boolean;
  selectedId: string;
  onClose: () => void;
}

export default function BankDetails({
  open,
  name,
  selectedId,
  onClose,
}: BankDetailsModalProps) {
  const isViewMode = Boolean(selectedId);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Bank Details</h2>
            <div className="btn-close" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            <div className="control_group">
              <label>Bank Name</label>
              <TextField
                placeholder="Bank Name"
                fullWidth
                value={name}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
